import List from "components/List/List";
import { useDispatch } from "react-redux";
import { formatFileSize } from "utils/helpers";
import { RiPlayCircleFill } from "react-icons/ri";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import { setNavbarTitle } from "features/navbar/navbarSlice";
import utilityStyles from "styles/modules/Utility.module.scss";
import { 
  useDownloadAudioFileMutation, 
  useGetAudioFileQuery 
} from "features/audioFiles/audioFilesApiSlice";

import { Globals } from "utils/styleconfig";
import Button from "components/UI/Button/Button";

const AudioFile = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();

  const audioRef = useRef(null);
  const [audioURL, setAudioURL] = useState(null);

  useEffect(() => {
    dispatch(setNavbarTitle("Audio File"));
  }, [dispatch]);

  const { data: audioFile } = useGetAudioFileQuery(params?.id);

  const [fetchAudioBlob, { isLoading }] = useDownloadAudioFileMutation();

  const handlePlayAudio = async () => {
    try {
      const blob = await fetchAudioBlob(params.id).unwrap();
      const url = window.URL.createObjectURL(blob);
      setAudioURL(url);
      if (audioRef.current) {
        audioRef.current.load();
        audioRef.current.play();
      }
    } catch (error) {
      console.error("Audio playback failed:", error);
    }
  };


  const audioData = [
    { label: "Filename", value: audioFile?.filename },
    { label: "Filesize", value: formatFileSize(Number(audioFile?.filesize)) },
    { label: "Location", value: audioFile?.location },
    { label: "category", value: audioFile?.category },
    { label: "Info Absolute Directory", value: audioFile?.info?.absolute_directory || "" },
    { label: "Info Mounted Directory", value: audioFile?.info?.mounted_directory || "" },
    { label: "created By", value: `${audioFile?.created_by?.firstname} ${audioFile?.created_by?.lastname}` },
    { label: "Date Created", value: new Date(audioFile?.created_at).toLocaleString() },
  ];

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
          <List
            customStyle={` ${utilityStyles.grid} ${utilityStyles.gap10} `}
            data={audioData}
          />
        </div>
        <div >
          <Button onClick={handlePlayAudio} disabled={isLoading}>
            <RiPlayCircleFill size={35} color={Globals.colorDarkBlue} />
          </Button>
          {audioURL && (
            <audio ref={audioRef} controls style={{ marginTop: "1rem" }}>
              <source src={audioURL} type="audio/wav" />
              Your browser does not support the audio element.
            </audio>
          )}
        </div>
      </div>
    </>
  )
}

export default AudioFile